import React from "react";
import DrawerRemoveObjectComponent from "./DrawerRemoveObjectComponent";
import DrawerGoBackComponent from "./DrawerGoBackComponent";
import { CurrentDrawerOpenType } from "../../../state/slices/RightDrawerSlice";
import CMRSliderComponent, { SliderType } from "./CMRSliderComponent";
import BSUPatientHeader from "./BSUPatientHeader";

const CMRConsoleComponent = (): JSX.Element => {
    return (
        <>
            <BSUPatientHeader title={"Surgeon Console"} />
            <section className="sliderContainer">
                <CMRSliderComponent type={SliderType.Console} title={"Rotate"} />
                <DrawerRemoveObjectComponent
                    classes={"mt-35 onlyDesktop"}
                    type={"console"}
                    payload={"console"}
                />
                <DrawerGoBackComponent classes="onlyDesktop" type={CurrentDrawerOpenType.Console} />
            </section>
        </>
    );
};

export default CMRConsoleComponent;
